module.exports = __webpack_public_path__ + "static/media/49.029452ef.gif";